import React from 'react';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "./AgendaUnaCita.css"
//import Info from './Modal';
//import Tarjeta from './Tarjeta';
import HorariosTable from './HorariosTable';
export default function HorariosLawyer( { idlawyer , state } ) {

  console.log( "HorariosLawyer = " , state)


  return (<>
    <h3 className='title'>Horarios Abogado {state.name} </h3>
    {/*<div id='bar-filtros' className='bar-filtros'>
      <h2 className='filtros-title'>Filtros</h2>
       <div className='d-flex'>
        <div className='row flex-start filter-group '>
          <select className='select-filter' defaultValue={1}>
            <option className='option-filter' value={1}>Especialidad</option>
          </select>
          <select className='select-filter ' defaultValue={3}>
            <option className='option-filter' value={3}>Estado</option>
          </select>
        </div>
      </div> 
    </div>*/}
    <div className='mt-5 container '>
      <div className="mt-5 card" >
        {/*<Tarjeta/>*/}
        <HorariosTable idlawyer={idlawyer}></HorariosTable>
      </div>
    </div>
  </>);
}
